import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { useThemeStore } from "./stores/useThemeStore";
import MonthlySummaryPage from "./features/monthly-summary/page";
import TaxPlannerPage from "./features/tax-planner/page";
import LoginPage from "./pages/LoginPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SettingsPage from "./features/settings/page";
import BudgetPage from "./features/budget/page";
import RecurringExpensePage from "./features/recurring-expenses/page";
import AccountsPage from "./features/accounts/page";
import BillsPage from "./features/bills/page";
import BillEditorPage from "./features/bills/BillEditorPage";
import FriendsPage from "./features/friends/page";
import PublicBillPage from "./features/bills/public/PublicBillPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./layout/AppLayout";
import { FeatureRoute } from "./features/feature-flags/components/FeatureGate";
import { useFeatureFlagStore } from "./features/feature-flags/store/useFeatureFlagStore";
import { FeatureFlag } from "./features/feature-flags/types/featureFlags.types";

export default function App() {
  const isDark = useThemeStore((s) => s.isDark);
  useEffect(() => {
    void useFeatureFlagStore.getState().init();
  }, []);
  return (
    <BrowserRouter>
      <NuqsAdapter>
        <Toaster
          theme={isDark ? "dark" : "light"}
          position="top-center"
          richColors
        />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/b/:token" element={<PublicBillPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<MonthlySummaryPage />} />
              <Route path="/accounts" element={<AccountsPage />} />
              <Route
                path="/tax-planner"
                element={
                  <FeatureRoute flag={FeatureFlag.TaxPlanner}>
                    <TaxPlannerPage />
                  </FeatureRoute>
                }
              />
              <Route
                path="/api-keys"
                element={<Navigate to="/settings?tab=api-keys" replace />}
              />
              <Route
                path="/split-groups"
                element={<Navigate to="/friends?tab=groups" replace />}
              />
              <Route path="/settings" element={<SettingsPage />} />
              <Route
                path="/budget"
                element={
                  <FeatureRoute flag={FeatureFlag.Budget}>
                    <BudgetPage />
                  </FeatureRoute>
                }
              />
              <Route path="/bills" element={<BillsPage />} />
              <Route path="/bills/:id" element={<BillEditorPage />} />
              <Route path="/friends" element={<FriendsPage />} />
              <Route
                path="/recurring-expenses"
                element={
                  <FeatureRoute flag={FeatureFlag.Recurring}>
                    <RecurringExpensePage />
                  </FeatureRoute>
                }
              />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </NuqsAdapter>
    </BrowserRouter>
  );
}
